/**
 * Core
 */
import React from 'react'
import { useEffect } from 'react';

/**
 * Components
 */
import Footer from '../components/footer'
import LightGallery from 'lightgallery/react';

// import styles
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css'


import lgZoom from 'lightgallery/plugins/zoom';
import lgThumbnail from 'lightgallery/plugins/thumbnail';

import fjGallery from 'flickr-justified-gallery';


/**
 * Hooks
 */
import useScrollTrigger from '../hooks/scroll-trigger.hook'


const Meeting = () => {

    useScrollTrigger('.reveal')


    useEffect(() => {
        fjGallery(document.querySelectorAll('.gallery'), {
          itemSelector: '.gallery__item',
          rowHeight: 300,
          lastRow: 'start',
          gutter: 2,
          rowHeightTolerance: 0.1,
          calculateItemsHeight: false,
        });
      }, []);


      const gallery = ['UKCXA-03741.jpg', 'UKCXA-03752.jpg', 'UKCXA-03756.jpg', 'UKCXA-03794.jpg', 'UKCXA-03804.jpg', 'UKCXA-03832.jpg', 'UKCXA-03883.jpg', 'UKCXA-03890.jpg', 'UKCXA-03950.jpg', 'UKCXA-04076.jpg', 'UKCXA-04083.jpg', 'UKCXA-04178.jpg', 'UKCXA-04184.jpg', 'UKCXA-04198.jpg', 'UKCXA-04217.jpg', 'UKCXA-04223.jpg', 'UKCXA-04242.jpg', 'UKCXA-04252.jpg', 'UKCXA-04269.jpg', 'UKCXA-04270.jpg', 'UKCXA-04284.jpg', 'UKCXA-04290.jpg', 'UKCXA-04307.jpg', 'UKCXA-04363.jpg', 'UKCXA-04372.jpg', 'UKCXA-04398.jpg', 'UKCXA-04404.jpg', 'UKCXA-04462.jpg', 'UKCXA-04466.jpg', 'UKCXA-04476.jpg', 'UKCXA-04477.jpg', 'UKCXA-04493.jpg', 'UKCXA-04506.jpg', 'UKCXA-04509.jpg', 'UKCXA-04515.jpg', 'UKCXA-04524.jpg', 'UKCXA-04536.jpg', 'UKCXA-04546.jpg', 'UKCXA-04552.jpg', 'UKCXA-04556.jpg', 'UKCXA-04560.jpg', 'UKCXA-04563.jpg', 'UKCXA-04566.jpg', 'UKCXA-04571.jpg', 'UKCXA-04576.jpg', 'UKCXA-04582.jpg', 'UKCXA-04585.jpg', 'UKCXA-04592.jpg', 'UKCXA-04595.jpg', 'UKCXA-04597.jpg', 'UKCXA-04599.jpg', 'UKCXA-04602.jpg', 'UKCXA-04604.jpg', 'UKCXA-04624.jpg', 'UKCXA-04626.jpg', 'UKCXA-04629.jpg', 'UKCXA-04631.jpg', 'UKCXA-04650.jpg', 'UKCXA-04690.jpg', 'UKCXA-04705.jpg']

    
    return (
        <>
            <section className='bg-white text-ai-gray-900 py-16'>
                <div>
                    <h1 className='self-center bg-gradient-analagous-rose-triad-orange text-center'>Networking Meeting</h1>
                </div>
            </section>
            <section className='bg-gradient-pastel text-ai-gray-900 pt-16'>
                <div>
                    <p className='reveal top'>The UK’s CX Community gathered at Ipsos London HQ last week for a series of high-profile events.</p>
                    <p className='reveal top'>First, members of the UKCXA Steering Committee sat in on a round table discussing improving the quality and value of the Awards, delivering a blistering array of ideas and precious insights for future events.</p>
                    <p className='reveal top'>Then, Ipsos’ Matthew Chatterton took time to demonstrate the changing customer landscape based on their research. Finally, Lee Jones from Elev-8 took attendees through a set of exercises to improve our networking skills, culminating in an hour of catching-up, CX chat and discussion over nibbles and drinks to round off a highly valuable day.</p>
                    <p className='reveal top'>As a demonstration of why in-person events offer value that remote can never compete with, the day provided many valuable lessons and welcome contact for CXers.</p>
                </div>
            </section>

            <section className='bg-white text-ai-gray-900'>
                <div>
                        <LightGallery
                           plugins={[lgZoom, lgThumbnail]}
                           mode="lg-fade"
                           pager={false}
                           thumbnail={true}
                           galleryId={'nature'}
                           autoplayFirstVideo={false}
                           elementClassNames={'gallery'}
                           mobileSettings={{
                             controls: true,
                             showCloseIcon: true,
                             download: false,
                             rotate: false,
                           }}
                            >
                            {gallery.map((img, index) => (
                           <a   key={index}
                                className="gallery__item"
                                data-src={`./images/sc-meeting/${img}`}
                                >
                                <img
                                    className="img-responsive"
                                    src={`./images/sc-meeting/${img}`}
                                />
                            </a>
                        ))}
                        </LightGallery>

                </div>
            </section>

            

            <section className='pb-0 border-t border-t-ai-gray-800'>
                <Footer />
            </section>
        </>
    )
}

export default Meeting